<div class="campaign-survey-container">
  <!-- Header with close button -->
  <div class="header">
    <!-- <button class="close-btn" (click)="onClose()">
      <span>&times;</span>
    </button> -->
  </div>

  <!-- Company Info Section -->
  <div class="company-info" *ngIf="campaignDetails">
    <div class="logo-container">
      <div class="logo">
        <img
          *ngIf="campaignDetails.campaignLogo"
          [src]="campaignDetails.campaignLogo"
          alt="Campaign Logo"
          class="campaign-logo"
        />
        <span *ngIf="!campaignDetails.campaignLogo" class="logo-text">RR</span>
      </div>
    </div>
    <div class="company-name">
      {{ campaignDetails.advertiserName || "MSR Infraa" }}
    </div>
    <div class="project-title">
      {{ campaignDetails.campaignTitle || "RR Wishtales" }}
    </div>
    <div class="project-description">
      {{ getDisplayDescription() }}
      <span
        *ngIf="shouldShowSeeMore()"
        class="see-more"
        (click)="toggleDescription()"
      >
        {{ isDescriptionExpanded ? "See less" : "See more" }}
      </span>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading campaign details...</p>
  </div>

  <!-- Survey Questions -->
  <div class="survey-section" *ngIf="!isLoading">
    <!-- Dynamic Questions from API -->
    <div
      class="question-card"
      *ngFor="let question of questions; let i = index"
    >
      <h3 class="question-title">
        {{ question.question }}
        <span class="required-asterisk" *ngIf="question.type !== 'Toggle'"
          >*</span
        >
      </h3>

      <!-- Text Input -->
      <div *ngIf="question.type === 'Text'" class="input-container">
        <input
          type="text"
          class="text-input"
          [placeholder]="getQuestionPlaceholder(question.type)"
          [value]="formAnswers['question_' + i]"
          (input)="onAnswerChange(i, $any($event.target).value, question.type)"
        />
      </div>

      <!-- Radio Buttons -->
      <div *ngIf="question.type === 'Radio'" class="option-group">
        <label
          *ngFor="let option of parseAnswerOptions(question.Answer)"
          class="radio-option"
        >
          <input
            type="radio"
            [name]="'question_' + i"
            [value]="option"
            [checked]="formAnswers['question_' + i] === option"
            (change)="onAnswerChange(i, option, question.type)"
          />
          <span class="radio-label">{{ option }}</span>
        </label>
      </div>

      <!-- Dropdown -->
      <div *ngIf="question.type === 'Dropdown'" class="dropdown-container">
        <select
          class="dropdown"
          [value]="formAnswers['question_' + i]"
          (change)="onAnswerChange(i, $any($event.target).value, question.type)"
        >
          <option value="">Select an option</option>
          <option
            *ngFor="let option of parseAnswerOptions(question.Answer)"
            [value]="option"
          >
            {{ option }}
          </option>
        </select>
      </div>

      <!-- Checkboxes -->
      <div *ngIf="question.type === 'Checkbox'" class="option-group">
        <label
          *ngFor="let option of parseAnswerOptions(question.Answer)"
          class="checkbox-option"
        >
          <input
            type="checkbox"
            [value]="option"
            [checked]="formAnswers['question_' + i]?.includes(option)"
            (change)="onAnswerChange(i, option, question.type)"
          />
          <span class="checkbox-label">{{ option }}</span>
        </label>
      </div>

      <!-- Number Input -->
      <div *ngIf="question.type === 'Number'" class="input-container">
        <input
          type="number"
          class="text-input no-spinner"
          [placeholder]="getQuestionPlaceholder(question.type)"
          [value]="formAnswers['question_' + i]"
          (input)="onAnswerChange(i, $any($event.target).value, question.type)"
        />
      </div>


      <!-- Toggle Switch -->
      <div *ngIf="question.type === 'Toggle'" class="toggle-container">
        <label class="toggle-switch">
          <input
            type="checkbox"
            [checked]="
              formAnswers['question_' + i] === 'Yes' ||
              formAnswers['question_' + i] === true
            "
            (change)="
              onAnswerChange(
                i,
                $any($event.target).checked ? 'Yes' : 'No',
                question.type
              )
            "
          />
          <span class="toggle-slider"></span>
          <span class="toggle-label">{{
            formAnswers["question_" + i] === "Yes" ||
            formAnswers["question_" + i] === true
              ? "Yes"
              : "No"
          }}</span>
        </label>
      </div>
    </div>
  </div>

  <!-- Continue Button -->
  <div class="button-container">
    <!-- <div class="form-validation-info" *ngIf="!isFormValid() && !isSubmitting">
      <small class="validation-text">
        Please fill in all required fields marked with *
      </small>
    </div> -->
    <button
      class="continue-btn"
      [disabled]="isSubmitting || !isFormValid()"
      (click)="onContinue()"
    >
      Submit
    </button>
  </div>
</div>
